import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

const ITEMS = [["new_order", "New order created"], ["dispatched", "Order dispatched"], ["status", "Order status changed"], ["low_stock", "Low stock alert"]];

export function WhatsAppSettingsCard() {
  const [s, setS] = useState(null);
  const [num, setNum] = useState("");
  const [lvl, setLvl] = useState("5");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/whatsapp/settings").then((r) => { setS(r.data); setNum(r.data.whatsapp || ""); setLvl(String(r.data.low_stock_default)); }).catch(() => {}); }, []);
  if (!s) return null;
  const save = async (patch = {}) => {
    setBusy(true);
    try {
      const { data } = await api.put("/whatsapp/settings", { whatsapp: num.trim() || null, notify: { ...s.notify, ...(patch.notify || {}) }, low_stock_default: Number(lvl) || 0 });
      setS(data); setNum(data.whatsapp || "");
      toast.success("WhatsApp settings saved");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <section className="mt-8 rounded-2xl border border-slate-200 bg-white p-5" data-testid="whatsapp-settings">
      <div className="flex items-center gap-2"><MessageCircle className="h-5 w-5 text-emerald-600" /><h2 className="font-display text-lg font-bold">WhatsApp notifications</h2></div>
      <div className="mt-4 grid gap-3 sm:grid-cols-[1fr_160px_auto] sm:items-end">
        <label className="space-y-1.5 text-sm font-medium text-slate-700">Your WhatsApp number
          <Input type="tel" placeholder="+923001234567" value={num} onChange={(e) => setNum(e.target.value)} className="h-11" data-testid="whatsapp-owner-number" /></label>
        <label className="space-y-1.5 text-sm font-medium text-slate-700">Default low stock level
          <Input inputMode="decimal" value={lvl} onChange={(e) => setLvl(e.target.value)} className="money h-11" data-testid="whatsapp-low-stock-default" /></label>
        <button onClick={() => save()} disabled={busy} className="h-11 rounded-xl bg-slate-900 px-5 text-sm font-semibold text-white disabled:opacity-50" data-testid="whatsapp-save">Save</button>
      </div>
      <p className="mt-3 text-sm text-slate-500" data-testid="whatsapp-destination">
        {s.whatsapp ? <>Alerts go to <span className="money font-semibold text-slate-900">{s.whatsapp}</span></> : "Add your WhatsApp number to receive alerts"}
      </p>
      <div className="mt-3 divide-y divide-slate-100">
        {ITEMS.map(([k, label]) => (
          <label key={k} className="flex items-center justify-between py-3 text-sm font-medium text-slate-800">
            {label}
            <Switch checked={s.notify[k]} disabled={busy} onCheckedChange={(v) => save({ notify: { [k]: v } })} data-testid={`whatsapp-toggle-${k}`} />
          </label>
        ))}
      </div>
    </section>
  );
}
